import React from "react";

function Brokerage() {
  return (
    <div className="container">

      <div className="row py-4 py-md-5 mt-4 mt-md-5 text-center border-top">

        {/* Left Section */}
        <div className="col-12 col-md-8 mb-4 mb-md-0 px-3 px-md-4">

          <a href="#" style={{ textDecoration: "none" }}>
            <h3 className="fs-5">Brokerage Calculator</h3>
          </a>

          <ul
            className="text-muted mt-3"
            style={{ textAlign: "left", lineHeight: "1.8" }}
          >
            <li>
              Call & Trade and RMS auto-squareoff: Additional charges of ₹50 + GST per order.
            </li>

            <li>
              Digital contract notes will be sent via e-mail.
            </li>

            <li>
              Physical copies of contract notes, if required, shall be charged ₹20 per contract note. Courier charges apply.
            </li>

            <li>
              For NRI account (non-PIS), 0.5% or ₹100 per executed order for equity (whichever is lower).
            </li>

            <li>
              For NRI account (PIS), 0.5% or ₹200 per executed order for equity (whichever is lower).
            </li>

            <li>
              If the account is in debit balance, any order placed will be charged ₹40 per executed order instead of ₹20.
            </li>
          </ul>
        </div>

        {/* Right Section */}
        <div className="col-12 col-md-4 px-3 px-md-4">
          <a href="#" style={{ textDecoration: "none" }}>
            <h3 className="fs-5">List of charges</h3>
          </a>
        </div>

      </div>

    </div>
  );
}

export default Brokerage;